export default {"src":"/_next/static/media/refreshBlue.5caab007.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};